export default __webpack_public_path__ + "static/media/ye.8bc8f5f0.svg";